/// <amd-module name="Test/TestResultHistory/DateUtils" />
export function addDays(date: Date, days: number, adjustOffset: boolean = false): Date {
    let newDate = <Date>new Date(); // Explicit cast here because of Date declare override at top of file.
    newDate.setTime(date.getTime() + days * 86400000);
    if (adjustOffset) {
        newDate = adjustOffsetForTimes(date, newDate);
    }

    return newDate;
}

export function adjustOffsetForTimes(oldDate: Date, newDate: Date, applicationDate?: Date): Date {

    // this function should be used if the offset between the old date and new date is different
    // and their difference is to be applied to the applied date passed in.
    // for eg. if the oldDate is March 11 00:00 AM 7GMT and the newDate is March 9 23:00 PM 8GMT
    // then there is a offset difference of 1 hour. This will happen when you use addDays(oldDate, -1)
    // because of the offset difference the result you will get March 9 23:00 PM 8GMT instead of March 10 00:00 AM 8GMT
    // hence the offset is applied to March 9 23:00 PM to get March 10 00:00 AM 8GMT 

    let setDate = newDate;

    if (applicationDate != null) {
        setDate = applicationDate;
    }

    let oldOffset = oldDate.getTimezoneOffset();
    let newOffset = newDate.getTimezoneOffset();
    if (oldOffset !== newOffset) {
        setDate = addDays(setDate, (newOffset - oldOffset) / (60 * 24));
    }

    return setDate;
}

export function convertDateToDateString(date: Date): string {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    let array = [(month <= 9 ? "0" + month : month), (day <= 9 ? "0" + day : day), year];
    return array.join("/");
}
